import {
  NavClickHandleClick,
  ExpandContentHandleClick,
  SelectContentHandleClick,
  CTAClickHandleClick,
} from 'helpers-ga4';

document.addEventListener('DOMContentLoaded', () => {
  const navClickLinks = `[data-ga4-event-type*="nav_click"]`;

  document.querySelectorAll(navClickLinks).forEach((link) => {
    link.addEventListener('click', NavClickHandleClick);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const clickLinks = `details [data-ga4-event-type*="expand_content"]`;
  document.querySelectorAll(clickLinks).forEach((item) => {
    item.addEventListener('click', ExpandContentHandleClick);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a').forEach((item) => {
    if (item.closest('#stickyHeader')) {
      console.log('invalid parent element');
    } else if (item.closest('.footer')) {
      console.log('invalid parent element');
    } else {
      // if url is not /account/login
      if (
        item.href.includes('/account/login') ||
        item.href.includes('/account/register') ||
        item.href.includes('tools/recurring')
      ) {
        console.log('account url');
      } else if (item.getAttribute('data-ga4-cta-type')) {
        item.addEventListener('click', CTAClickHandleClick);
      } else if (item.getAttribute('data-ga4-nav-type')) {
        item.addEventListener('click', NavClickHandleClick);
      } else {
        item.addEventListener('click', SelectContentHandleClick);
      }

      if (item.href.includes('tools/recurring/get-subscription-access')) {
        document.title = 'Get Subscription Access | Petivity';
      }
    }
  });
});

// Recharge Start
document.addEventListener('Recharge::slot::mounted', (event) => {
  const {name, pathname} = event.detail;
  if (pathname === '/overview') {
    // PTV-14722 - Disable subscriptions grid view
    //subscriptionsInit();
  } else if (pathname.includes('subscriptions')) {
    subscriptionInit(pathname);
  }
});

document.addEventListener('Recharge::location::change', (event) => {
  const {name, pathname} = event.detail;
  if (pathname.includes('subscriptions')) {
    subscriptionInit(pathname);
  }
});

document.addEventListener('Recharge::slot::mounted', (e) => {
  if (e.detail?.name !== 'dialog-header') return;
  const subscriptionTextEl = document.querySelector(
    '.dialog-header-populate-subscription-id',
  );
  if (!subscriptionTextEl) return;
  const params = new URLSearchParams(location.search);
  const subscriptionId = params.get('subscription');
  const swapProduct = params.get('swapProduct');
  subscriptionTextEl.textContent = subscriptionId
    ? `Subscription ID: ${subscriptionId}`
    : '';

  if (swapProduct) {
    document
      .querySelector('#custom-petivity-dialog-footer-plan-copy')
      ?.classList.remove('custom-petivity-recharge-hidden');
  } else if (subscriptionId) {
    document
      .querySelector('#custom-petivity-dialog-heading')
      ?.classList.remove('custom-petivity-recharge-hidden');
  }

  const petivityDialogtrigger = document.querySelector(
    '#custom-petivity-recharge-open-modal-dialog',
  );
  if (!petivityDialogtrigger) return;
  if (petivityDialogtrigger.classList.contains('initialized')) return;
  petivityDialogtrigger.classList.add('initialized');
  petivityDialogtrigger.addEventListener('click', (e) => {
    e.preventDefault();
    window.dispatchEvent(
      new CustomEvent('petivity-recharge-dialog:open', {
        detail: {target: petivityDialogtrigger},
      }),
    );
  });
});

const rechargeAPI = {
  session: null,

  async authenticate() {
    if (!this.session) {
      this.session = await recharge.auth
        .loginCustomerPortal()
        .catch((error) => {
          console.error('Authentication failed:', error);
          throw error;
        });
    }
    return this.session;
  },

  async fetchSubscriptions() {
    const response = await recharge.subscription
      .listSubscriptions(this.session, {
        limit: 10,
        sort_by: 'id-asc',
        status: 'Active',
      })
      .catch((error) => {
        console.error('Fetching subscriptions failed:', error);
        throw error;
      });
    return response.subscriptions;
  },

  async fetchSubscriptionById(subscriptionId) {
    const response = await recharge.subscription
      .getSubscription(this.session, subscriptionId)
      .catch((error) => {
        console.error('Fetching subscription by ID failed:', error);
        throw error;
      });
    return response;
  },
};

function getSubscriptionIdFromUrl() {
  const pathSegments = window.location.pathname.split('/');
  const subscriptionsIndex = pathSegments.indexOf('subscriptions');
  if (
    subscriptionsIndex !== -1 &&
    pathSegments.length > subscriptionsIndex + 1
  ) {
    return pathSegments[subscriptionsIndex + 1];
  }
  return null;
}

async function subscriptionsInit() {
  console.log('Initializing subscriptions...');
  try {
    await rechargeAPI.authenticate();
    const subscriptions = await rechargeAPI.fetchSubscriptions();
    console.log(subscriptions);
    if (subscriptions.length > 0) {
      const element = document.getElementById('recharge-overview-header');
      if (!element) {
        console.error("Element with ID 'recharge-overview-header' not found.");
        return;
      }
      let tableHTML = `
          <table class="recharge-table">
            <thead>
              <tr>
                <th>Subscription ID</th>
                <th>Product</th>
                <th>Tracker ID</th>
              </tr>
            </thead>
            <tbody>
        `;

      // Store subscription data globally
      window._subscriptionsData = subscriptions;

      for (let i = 0; i < subscriptions.length; i++) {
        const subscription = subscriptions[i];
        const trackerId =
          subscription.properties.find((prop) => prop.name === '_tracker_id')
            ?.value || '';
        tableHTML += `
          <tr>
            <td>${subscription.id}</td>
            <td>${subscription.product_title}</td>
            <td>${trackerId}</td>
          </tr>
        `;
      }
      tableHTML += `
            </tbody>
          </table>
        `;
      element.innerHTML = tableHTML;
    }
  } catch (error) {
    console.error('Error initializing subscriptions:', error);
  }
}

async function subscriptionInit(pathname) {
  console.log('Initializing subscription...');

  const isSubscriptionItem = pathname.includes('/subscriptions/');

  if (isSubscriptionItem) {
    document.querySelector('#custom-petivity-default-heading')?.classList.add('custom-petivity-recharge-hidden');
    document.querySelector('#custom-petivity-subscriptions-footer')?.classList.add('custom-petivity-recharge-hidden');

    try {
      await rechargeAPI.authenticate();
      const subscriptionId = getSubscriptionIdFromUrl();
      const subscriptionDetails = subscriptionId
        ? await rechargeAPI.fetchSubscriptionById(subscriptionId)
        : null;
      console.log(subscriptionId);
      console.log(subscriptionDetails);
      if (subscriptionDetails !== null) {
        const trackerId =
          subscriptionDetails.properties.find(
            (prop) => prop.name === '_tracker_id',
          )?.value || '';

        // Store individual subscription data globally
        window._subscriptionsData = [subscriptionDetails];

        const element = document.getElementById(
          'recharge-subscriptions-header',
        );
        const element2 = document.getElementById('recharge-overview-header');
        if (!element && !element2) {
          console.error(
            "Element with ID 'recharge-overview-header' not found.",
          );
          return;
        }

        const tableHTML = `<h2 class="custom-petivity-recharge-h2">Subscription ID: ${subscriptionDetails.id}</h2>`;
        if (element) {
          element.innerHTML = tableHTML;
        }
        if (element2) {
          element2.innerHTML = tableHTML;
        }

        document.querySelector('#custom-petivity-subscription-item-heading')?.classList.remove(
          'custom-petivity-recharge-hidden',
        );
        document.querySelector('#custom-petivity-subscription-item-footer')?.classList.remove(
          'custom-petivity-recharge-hidden',
        );
        const modalOpen = document.querySelector(
          '#custom-petivity-recharge-open-modal',
        );
        if (modalOpen && !modalOpen.classList.contains('initialized')) {
          modalOpen?.classList.add('initialized');
          modalOpen.addEventListener('click', (e) => {
            window.dispatchEvent(
              new CustomEvent('petivity-recharge-dialog:open', {
                detail: {target: modalOpen},
              }),
            );
          });
        }
      }
    } catch (error) {
      console.error('Error initializing subscriptions:', error);
    }
  } else {
    document.querySelector('#custom-petivity-subscription-item-heading')?.classList.add(
      'custom-petivity-recharge-hidden',
    );
    document.querySelector('#custom-petivity-subscription-item-footer')?.classList.add(
      'custom-petivity-recharge-hidden',
    );
    document.querySelector('#custom-petivity-default-heading')?.classList.remove(
      'custom-petivity-recharge-hidden',
    );
    document.querySelector('#custom-petivity-subscriptions-footer')?.classList.remove(
      'custom-petivity-recharge-hidden',
    );
  }
}

// Function to get Monitor ID data
function getMonitorIdData() {
  return {
    subscriptions: window._subscriptionsData || [],
    getMonitorIdBySubscriptionId: function (subscriptionId) {
      const subscription = this.subscriptions.find(
        (sub) => sub.id === subscriptionId,
      );
      return subscription ? subscription._monitorId : null;
    },
  };
}

// Store subscription data globally
window._subscriptionsData = [];
window.getMonitorIdData = getMonitorIdData;
// Recharge End
